import { Cell } from '@/components/ui/shared/Table/Cell';
import { ProfileCell } from '@/components/ui/shared/Table/cells/ProfileCell';
import type { ProfileLike } from '@/components/ui/shared/Table/cells/ProfileCell';
import type { HideBelow } from '@/components/ui/shared/Table/types';
import type { ReactNode } from 'react';

export interface TableProfileCellProps {
  profile: ProfileLike;
  link?: string;
  secondary?: ReactNode;
  width?: string;
  hideBelow?: HideBelow;
  className?: string;
}

export function TableProfileCell({
  profile,
  link,
  secondary,
  width,
  hideBelow,
  className
}: TableProfileCellProps) {
  return (
    <Cell width={width} hideBelow={hideBelow} className={className}>
      <ProfileCell profile={profile} link={link} secondary={secondary} />
    </Cell>
  );
}
